import React from 'react'
import { useTaste } from '../contexts/TasteContext'
import { CAMPAIGN } from '../config/campaign'

const OrderSummary: React.FC = () => {
  const { selectedPack, hasCaviar, caviarPrice, quote, totalAmount } = useTaste()

  // Subtotal is always the product subtotal (pack + caviar). When a quote
  // exists, prefer its server-computed subtotal for consistency.
  const subtotal = quote ? quote.subtotal : selectedPack ? selectedPack.price + (hasCaviar ? caviarPrice : 0) : 0

  if (!selectedPack) return null

  return (
    <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
      <h3 className="text-lg font-bold !text-white mb-4 font-heading">
        Order Summary
      </h3>

      <div className="space-y-3">
        {/* Pack */}
        <div className="flex justify-between items-center text-base">
          <span className="!text-white/70">
            {selectedPack.label} Pack
          </span>
          <span className="font-semibold !text-white">
            ${selectedPack.price.toFixed(2)}
          </span>
        </div>

        {/* Caviar Add-on */}
        {hasCaviar && (
          <div className="flex justify-between items-center text-base">
            <span className="!text-white/70">
              Caviar Add-On
              {selectedPack.size === 8 && (
                <span className="ml-1 text-xs !text-[#DAA520]">(Special Rate)</span>
              )}
            </span>
            <span className="font-semibold !text-white">
              ${caviarPrice.toFixed(2)}
            </span>
          </div>
        )}

        {/* Subtotal */}
        <div className="flex justify-between items-center text-base">
          <span className="!text-white/70">Subtotal</span>
          <span className="font-semibold !text-white">${subtotal.toFixed(2)}</span>
        </div>

        {/* Shipping */}
        <div className="flex justify-between items-center text-base">
          <span className="!text-white/70">Shipping</span>
          {quote ? (
            <span className="font-semibold !text-white">${quote.shippingCost.toFixed(2)}</span>
          ) : (
            <span className="!text-white/50 text-sm">Calculated at checkout</span>
          )}
        </div>

        {/* Tax */}
        <div className="flex justify-between items-center text-base">
          <span className="!text-white/70">Tax</span>
          {quote ? (
            <span className="font-semibold !text-white">${quote.taxAmount.toFixed(2)}</span>
          ) : (
            <span className="!text-white/50 text-sm">Calculated at checkout</span>
          )}
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 pt-3 mt-3">
          <div className="flex justify-between items-center text-xl font-bold">
            <span className="!text-white">Total:</span>
            <span className="!text-white">${totalAmount.toFixed(2)}</span>
          </div>
          <p className="mt-3 text-xs !text-white/50">
            Ships via UPS 2-Day by {CAMPAIGN.shipDateDisplay} for delivery before Labor Day weekend.
          </p>
        </div>
      </div>
    </div>
  )
}

export default OrderSummary
